import { useMutation } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

type SearchParams = {
  listId: string;
  companyIds: string[];
};

export const useDeleteCompanies = () => {
  const { apiClient } = useSalesyApiClient();

  const deleteCompanies = async (searchParams: SearchParams) => {
    return apiClient.listsStatic.removeItems({
      id: searchParams.listId,
      requestBody: { items: searchParams.companyIds },
    });
  };

  const mutation = useMutation({
    mutationKey: ["delete-companies"],
    mutationFn: deleteCompanies,
  });

  return {
    ...mutation,
    deleteCompanies: mutation.mutate,
  };
};
